<template>
  <transition name="loading-fade">
    <div v-if="showing" class="loading-overlay">
      <div class="loader">
        <span class="is-src-only">{{ loadingtext }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'loadingoverlay',
  props: {
    loadingtext: { type: String, required: false, default: 'Loading' },
  },
  data() {
    return {
      showing: false,
    };
  },
  mounted() {
    if (window.eventBus) {
      window.eventBus.$on('overlay.on', () => {
        this.showing = true;
      });

      window.eventBus.$on('overlay.off', () => {
        this.showing = false;
      });
    }
  },
};
</script>
